import React, { useState } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';
import { message } from 'antd';

const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

const PrivacyPolicy = () => {
  const [amountRupees, setAmountRupees] = useState(100);
  const [processing, setProcessing] = useState(false);

  const createOrder = async () => {
    if (!amountRupees || amountRupees <= 0) {
      message.error('Please enter a valid amount.');
      return;
    }

    setProcessing(true);
    try {
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded || !window.Razorpay) {
        message.error('Unable to load the payment gateway. Please try again.');
        setProcessing(false);
        return;
      }

      const amountInPaise = Math.round(amountRupees * 100);
      const response = await api.post('/create-order', { amount: amountInPaise });

      if (!response.data.success) {
        message.error(response.data.message || 'Failed to create payment order.');
        setProcessing(false);
        return;
      }

      const { orderId, amount, currency, keyId, merchantOrderId } = response.data;

      const options = {
        key: keyId,
        amount,
        currency,
        name: 'Startup Business Partners',
        description: 'Payment',
        order_id: orderId,
        theme: { color: '#413AA4' },
        handler: async (paymentResult) => {
          try {
            const verifyRes = await api.post('/verify-order', {
              razorpay_order_id: paymentResult.razorpay_order_id,
              razorpay_payment_id: paymentResult.razorpay_payment_id,
              razorpay_signature: paymentResult.razorpay_signature,
              merchantOrderId
            });

            if (verifyRes.data.success) {
              message.success('Payment successful! Thank you.');
            } else {
              message.error(verifyRes.data.message || 'Payment verification failed.');
            }
          } catch (verifyError) {
            console.error('Payment verification error:', verifyError);
            message.error('We could not confirm your payment automatically. If money was deducted, please contact support.');
          } finally {
            setProcessing(false);
          }
        },
        modal: {
          ondismiss: () => setProcessing(false)
        }
      };

      const checkout = new window.Razorpay(options);
      checkout.on('payment.failed', (resp) => {
        message.error(`Payment failed: ${resp.error?.description || 'Please try again.'}`);
        setProcessing(false);
      });
      checkout.open();
    } catch (error) {
      console.error('Error in createOrder:', error);
      message.error('Failed to start payment. Please try again.');
      setProcessing(false);
    }
  };

  return (
    <div className="home-page">
      <Helmet>
        <title>Pay Now - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
          <section className="breadcrumb_area breadcrumb2 bgimage biz_overlay">
        <div className="bg_image_holder" style={{opacity: 1, backgroundImage: 'linear-gradient(to right, #413AA4, rgb(16 139 255))'}}>
          <img src="img/breadbg.jpg" alt="img/breadbg.jpg" />
        </div>
        <div className="container content_above">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                <h4 className="page_title">Privacy Policy</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb m-bottom-30">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-5">
                <div className="divider divider-simple text-center">
                  <h3>Privacy Policy</h3>
                </div>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-12">
                <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
                <h2 className="text-2xl font-bold mb-4">Make a Payment</h2>
                <input
                    type="number"
                    className="border rounded p-2 mb-4 w-full"
                    value={amountRupees}
                    onChange={(e) => setAmountRupees(Number(e.target.value))}
                    min="1"
                />
                <button
                    onClick={createOrder}
                    disabled={processing}
                    className="bt btn-primary"
                >
                    {processing ? 'Processing...' : 'Pay Now'}
                </button>
            </div>
        </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;